import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function UeberUns(): ReactElement {
  return (
    <PageShell
      title="Über uns"
      intro="Saldify macht Buchhaltung für Selbstständige, Freelancer und kleine Unternehmen einfach – modern, sicher und ohne Fachchinesisch."
    >
      <PageSection title="Unsere Mission">
        <p>
          Buchhaltung kostet Zeit, die kleinen Unternehmen oft fehlt. Wir glauben,
          dass jede und jeder den eigenen Zahlen ohne Hürden vertrauen können sollte.
          Deshalb entwickeln wir eine Software, die Rechnungen, Belege, Banking und
          Auswertungen an einem Ort zusammenführt – verständlich aufbereitet und
          jederzeit nachvollziehbar.
        </p>
      </PageSection>

      <PageSection title="Wer dahintersteht">
        <p>
          Saldify wird von CuiveMedia (Inhaber Brian Brelöer) aus Berlin betrieben –
          einem Team mit langjähriger Erfahrung in Webentwicklung, Hosting und
          digitalen Dienstleistungen. „Made in Germany" ist für uns kein Slogan,
          sondern Anspruch: Entwicklung, Betrieb und Datenhaltung erfolgen
          DSGVO-konform.
        </p>
      </PageSection>

      <PageSection title="Kontakt">
        <p>
          Fragen, Feedback oder eine Idee? Schreiben Sie uns über unsere{' '}
          <a href="/kontakt" className="text-primary-600 hover:underline">
            Kontaktseite
          </a>
          .
        </p>
      </PageSection>
    </PageShell>
  );
}
